import { Radio, Select, DatePicker } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import LoadingSpinnerInContainer from '../../UI/LoadingSpinnerInContainer/LoadingSpinnerInContainer';
import PubDateTypes from '../PubDateTypes';
import SaveAndCancelButtons from '../../Community/UI/SaveAndCancelButtons/SaveAndCancelButtons';
import BrowseLaneType from './BrowseLaneType';
import PubDateFromOptions from '../PubDateFromOptions';
import PubDateToOptions from '../PubDateToOptions';
import {
	getRelativeTimeframeAttributes,
	getBrowseFiltersByType,
} from '../../Community/util';
import { useSavedFilters } from '../containers/SavedFiltersDataStore';
import { useSavedFilter } from '../containers/SavedFilterDataStore';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import { LoadingSpinnerSize } from '../../UI/LoadingSpinner';

const { Option } = Select;

const { RangePicker } = DatePicker;

const dateFormat = 'MM/DD/YYYY';

AddEditPubDateFilter.propTypes = {
	browseRefinements: PropTypes.array,
	viewId: PropTypes.number,
	leaveEditMode: PropTypes.func,
	isMobile: PropTypes.func,
};

function AddEditPubDateFilter({
	browseRefinements,
	viewId,
	leaveEditMode,
	isMobile,
}) {
	const isMobileSize = isMobile();
	const [selectedPubDateType, setSelectedPubDateType] = React.useState(
		PubDateTypes['all'].key,
	);
	const [isLoading, setIsLoading] = React.useState(true);
	const [startingRange, setStartingRange] = React.useState('NOW/DAY');
	const [endingRange, setEndingRange] = React.useState('+14DAY]');
	const [startingDate, setStartingDate] = React.useState(new Date());
	const [endingDate, setEndingDate] = React.useState(
		new Date(new Date().setMonth(new Date().getMonth() + 1)),
	);

	const savedFiltersDataStore = useSavedFilters();
	const savedFilterDataStore = useSavedFilter();

	React.useEffect(() => {
		getSavedPubDateType();
	}, []);

	const onPubDateTypeChange = e => {
		setSelectedPubDateType(e.target.value);
	};

	const pubDateFilter =
		browseRefinements &&
		browseRefinements.find(
			br => br.browseLaneType === BrowseLaneType.PubDate.key,
		);

	const getCodeAttributeToSave = () => {
		switch (selectedPubDateType) {
			case PubDateTypes['frontlist'].key:
				return 'frontlist';
			case PubDateTypes['backlist'].key:
				return 'backlist';
			case PubDateTypes['relativeTimeframe'].key:
				return (
					'[' +
					startingRange +
					' TO ' +
					startingRange +
					'|' +
					endingRange
				);
			case PubDateTypes['absoluteTimeframe'].key:
				return (
					'[' +
					getFormattedDate(startingDate) +
					' TO ' +
					getFormattedDate(endingDate) +
					']'
				);
		}
	};

	const getFormattedDate = date => {
		date = new Date(date);
		var year = date.getFullYear();

		var month = (1 + date.getMonth()).toString();
		month = month.length > 1 ? month : '0' + month;

		var day = date.getDate().toString();
		day = day.length > 1 ? day : '0' + day;

		return year + '-' + month + '-' + day + 'T04:00:00.000Z';
	};

	const saveFilters = () => {
		var { savedFilters } = savedFiltersDataStore.state;
		var thisSavedFilter = savedFilters.filter(sf => sf.id === viewId)[0];
		if (selectedPubDateType === PubDateTypes['all'].key) {
			thisSavedFilter.browseRefinements = thisSavedFilter.browseRefinements.filter(
				tsf => tsf.browseLaneType !== BrowseLaneType.PubDate.key,
			);
		} else {
			if (pubDateFilter) {
				var thisRefinement = thisSavedFilter.browseRefinements.filter(
					tsf => tsf.browseLaneType === BrowseLaneType.PubDate.key,
				)[0];
				thisRefinement.code = getCodeAttributeToSave();
			} else {
				var newRefinement = {
					viewId: viewId,
					browseLaneType: BrowseLaneType.PubDate.key,
					code: getCodeAttributeToSave(),
				};
				thisSavedFilter.browseRefinements.push(newRefinement);
			}
		}

		thisSavedFilter.filtersByType = getBrowseFiltersByType(thisSavedFilter);
		savedFilterDataStore.updateFilters(thisSavedFilter);
		leaveEditMode();
	};

	const getSavedPubDateType = () => {
		if (!pubDateFilter) {
			setSelectedPubDateType(PubDateTypes['all'].key);
		} else if (pubDateFilter.code === 'frontlist') {
			setSelectedPubDateType(PubDateTypes['frontlist'].key);
		} else if (pubDateFilter.code === 'backlist') {
			setSelectedPubDateType(PubDateTypes['frontlist'].key);
		} else if (pubDateFilter.code.substring(0, 4) === '[NOW') {
			setSelectedPubDateType(PubDateTypes['relativeTimeframe'].key);
			const relativeTimeFrameAttributes = getRelativeTimeframeAttributes(
				pubDateFilter.code,
			);
			setStartingRange(relativeTimeFrameAttributes.startingRange);
			setEndingRange(relativeTimeFrameAttributes.endingRange);
		} else {
			setSelectedPubDateType(PubDateTypes['absoluteTimeframe'].key);
			const dateSplit = pubDateFilter.code.split(' TO ');
			setStartingDate(new Date(dateSplit[0].replace('[', '')));
			setEndingDate(new Date(dateSplit[1].replace(']', '')));
		}
		setIsLoading(false);
	};

	const onStartingRangeChange = value => {
		setStartingRange(value);
	};

	const getStartingRangeFromOptions = () => {
		return Object.keys(PubDateFromOptions).map(key => {
			return (
				<Option value={key} key={`pd-${key}`}>
					{PubDateFromOptions[key]}
				</Option>
			);
		});
	};

	const onEndingRangeChange = value => {
		setEndingRange(value);
	};

	const getEndingRangeFromOptions = () => {
		return Object.keys(PubDateToOptions).map(key => {
			return <Option value={key}>{PubDateToOptions[key]}</Option>;
		});
	};

	const onChange = (value, dateString) => {
		setStartingDate(dateString[0]);
		setEndingDate(dateString[1]);
	};

	const getSelectionArea = () => {
		switch (selectedPubDateType) {
			case PubDateTypes['relativeTimeframe'].key:
				return (
					<div className="relative relative-timeframe-selection">
						{!isMobileSize && <div className="arrow-down" />}
						<div className="pubdate-selection-frame">
							<div className="column pubdate-selection-text">
								Starting
							</div>
							<div className="column-spaced">
								<Select
									onChange={onStartingRangeChange}
									defaultValue={startingRange}
									value={startingRange}>
									{getStartingRangeFromOptions()}
								</Select>
							</div>
							<div className="column-spaced pubdate-selection-text">
								Looking out
							</div>
							<div className="column-spaced">
								<Select
									onChange={onEndingRangeChange}
									defaultValue={endingRange}
									value={endingRange}>
									{getEndingRangeFromOptions()}
								</Select>
							</div>
							<div className="clear" />
						</div>
					</div>
				);
			case PubDateTypes['absoluteTimeframe'].key:
				return (
					<div className="relative absolute-timeframe-selection">
						{!isMobileSize && <div className="arrow-down" />}
						<div className="pubdate-selection-frame">
							<RangePicker
								defaultValue={[
									moment(startingDate, dateFormat),
									moment(endingDate, dateFormat),
								]}
								format={dateFormat}
								onChange={onChange}
							/>
						</div>
					</div>
				);
			default:
				return <></>;
		}
	};

	return !isLoading ? (
		<div className="add-edit-category-filters">
			<Radio.Group size="small" value={selectedPubDateType}>
				{Object.keys(PubDateTypes).map(pubDateType => {
					return (
						<Radio.Button
							value={PubDateTypes[pubDateType].key}
							key={PubDateTypes[pubDateType].key}
							onChange={onPubDateTypeChange}>
							{PubDateTypes[pubDateType].label}
						</Radio.Button>
					);
				})}
			</Radio.Group>
			{getSelectionArea()}
			<SaveAndCancelButtons
				onSave={saveFilters}
				onCancel={leaveEditMode}
			/>
		</div>
	) : (
		<LoadingSpinnerInContainer size={LoadingSpinnerSize.small} />
	);
}

export default withIsMobile(AddEditPubDateFilter);
